import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Alerta, AlertasRes } from '@shared/models/alerta.t';

/**
 * Alertas y Notificaciones internas (contratos WP0 en `alerta.t.ts`).
 *
 * El listado vigente de un usuario viaja embebido en `Claims.alertas` y se
 * refresca únicamente al iniciar sesión o al hacer click en el avatar del
 * status-bar (sin polling). Este servicio expone solo las dos mutaciones que
 * el panel de notificaciones necesita: releer el listado bajo demanda y
 * marcar una alerta puntual como leída.
 */
@Injectable({
  providedIn: 'root',
})
export class AlertasService {
  private http = inject(HttpClient);
  private readonly baseUrl = '/api/alertas/';

  /** Alertas no resueltas del usuario autenticado (más recientes primero). */
  getAlertas(): Observable<AlertasRes> {
    return this.http.get<AlertasRes>(this.baseUrl);
  }

  /** Marca una alerta como leída (PENDIENTE → LEIDA). */
  marcarLeida(id: number): Observable<Alerta> {
    return this.http.post<Alerta>(`${this.baseUrl}${id}/leida/`, {});
  }

  /**
   * P04 (D11) — `POST /api/alertas/{id}/resuelta/` (`routes/common/
   * alertas.py`, propia de esta categoría). Para `categoria === 'VALIDACION'`
   * con `datos.rol === 'ASIGNADO'` resuelve la violación y sus notificaciones
   * hermanas; con `datos.rol === 'GESTOR'` resuelve solo esta notificación
   * (resumen agregado por alerta y corrida, D2 ajustado).
   */
  marcarResuelta(id: number): Observable<Alerta> {
    return this.http.post<Alerta>(`${this.baseUrl}${id}/resuelta/`, {});
  }
}
